import tippy, { type Props } from 'tippy.js';
import type { Attachment } from 'svelte/attachments';
import { whiteBgTippyOptions } from '../js/white-bg-tippy-options';

export { whiteBgTippyOptions };

// our usual data-tippy attribute is read once on DOMContentLoaded;
// for dynamic content in Svelte use this helper
export function tippyTooltip(
  content: string,
  options?: Partial<Props>,
): Attachment {
  return (element: Element) => {
    const popover = element.closest('[popover]');
    const appendTo = popover || document.body;

    const instance = tippy(element as HTMLElement, {
      content,
      appendTo,
      ...options,
    });
    return () => instance.destroy();
  };
}

export function tippyWhiteBgTooltip(content: string): Attachment {
  return tippyTooltip(content, whiteBgTippyOptions);
}
